import { Chip, type ChipProps } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	Reminder,
	ResourceKey,
} from "web_myplann/Reminders/Types/ReminderTypes";
import {
	ReminderBadgeVariant,
	resolveReminderBadge,
} from "web_myplann/Reminders/Utils/reminderBadge";

type BadgeConfig = {
	labelKey: ResourceKey;
	color: ChipProps["color"];
};

const BADGE_CONFIG: Record<
	Exclude<ReminderBadgeVariant, typeof ReminderBadgeVariant.None>,
	BadgeConfig
> = {
	[ReminderBadgeVariant.Soon]: {
		labelKey: Resources.Reminders.Badge.soon,
		color: "warning",
	},
	[ReminderBadgeVariant.Overdue]: {
		labelKey: Resources.Reminders.Badge.overdue,
		color: "error",
	},
	[ReminderBadgeVariant.Snoozed]: {
		labelKey: Resources.Reminders.Badge.snoozed,
		color: "default",
	},
};

type Props = {
	reminder: Reminder;
};

export const ReminderBadge = ({ reminder }: Props) => {
	const { t } = useResource();
	const variant = resolveReminderBadge(reminder);

	if (variant === ReminderBadgeVariant.None) {
		return null;
	}

	const config = BADGE_CONFIG[variant];

	return <Chip variant="tag" color={config.color} label={t(config.labelKey)} />;
};
